export function sortBy(array, value, ascending = true) {
  array.sort((a, b) => {
    const valueA = a[value].toLowerCase()
    const valueB = b[value].toLowerCase()

    if (ascending) {
      return ascendingCompare(valueA, valueB)
    } else {
      return descendingCompare(valueA, valueB)
    }

  })
  return array
}

export function sortByMultiple(array, value, value2, ascending = true) {
  array.sort((a, b) => {
    const valueA = a[value].toLowerCase()
    const valueB = b[value].toLowerCase()
    const value2A = a[value2].toLowerCase()
    const value2B = b[value2].toLowerCase()

    if (ascending) {
      let result = ascendingCompare(valueA, valueB)
      if (result === 0) {
        return (value2 === 'version') ? versionCompare(value2A, value2B) : ascendingCompare(value2A, value2B)
      } else {
        return result
      }
    } else {
      let result = descendingCompare(valueA, valueB)
      if (result === 0) {
        return (value2 === 'version') ? versionCompare(value2A, value2B, false) : descendingCompare(value2A, value2B)
      } else {
        return result
      }
    }

  })
  return array
}

function ascendingCompare(valueA, valueB) {
  if (valueA < valueB) return -1
  if (valueA > valueB) return 1
  return 0
}

function descendingCompare(valueA, valueB) {
  if (valueA > valueB) return -1
  if (valueA < valueB) return 1
  return 0
}

function versionCompare(valueA, valueB, ascending = true) {
  let valueAParts = valueA.split('.')
  let valueBParts = valueB.split('.')
  valueAParts = valueAParts.map(Number)
  valueBParts = valueBParts.map(Number)

  for (let i = 0; i < valueAParts.length; ++i) {
    if (valueBParts.length === i) return 1

    if (valueAParts[i] === valueBParts[i]) {
      continue
    } else if (ascending ? valueAParts[i] > valueBParts[i] : valueAParts[i] < valueBParts[i]) {
      return 1
    } else {
      return -1
    }
  }

  if (valueAParts.length !== valueBParts.length) return -1
  return 0
}



// WEBPACK FOOTER //
// ./src/utilities/array.utilities.js